import { render, staticRenderFns } from "./ShippingRules.vue?vue&type=template&id=59d97111&scoped=true&"
import script from "./ShippingRules.vue?vue&type=script&lang=js&"
export * from "./ShippingRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d97111",
  null
  
)

export default component.exports